import React from 'react'
import { OwReturn } from '@yy/one-icon'
import type { RouteConfig } from 'react-router-config'
import { withAsync } from '@/components/Async'
import Blank from '@/layouts/Blank'
import { withRedirect } from '@/components/Authorization'

const routes: RouteConfig[] = [
  {
    name: 'refund',
    menuTitle: 'menuTitle.reverse',
    path: '/refund',
    component: withRedirect(Blank),
    icon: <OwReturn />,
    authCode: 'refund',
    routes: [
      {
        menuTitle: 'reverse.list.title',
        component: withAsync(() => import(/* webpackChunkName: "reverse" */ '@/containers/Refund/List')),
        path: '/list',
        authCode: 'refund:management',
        exact: true,
      },
      {
        component: withAsync(() => import('@/containers/Refund/Create')),
        path: '/create',
        menuTitle: 'refund.list.create',
        hideInMenu: true,
        parentKeys: ['/refund/list'],
        // authCode: 'skus:management',
        exact: true,
      },
      {
        component: withAsync(() => import(/* webpackChunkName: "reverse" */ '@/containers/Refund/Detail')),
        path: '/detail',
        exact: true,
      },
    ],
  },
]

export default routes
